module.exports = __webpack_public_path__ + "static/media/logo.ed1af253.svg";